import { render, staticRenderFns } from "./StartupProfile.vue?vue&type=template&id=1da23990&"
import script from "./StartupProfile.vue?vue&type=script&setup=true&lang=js&"
export * from "./StartupProfile.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports